import { render, staticRenderFns } from "./PhoneInfo.vue?vue&type=template&id=bc6af530&scoped=true&"
import script from "./PhoneInfo.vue?vue&type=script&lang=js&"
export * from "./PhoneInfo.vue?vue&type=script&lang=js&"
import style0 from "./PhoneInfo.vue?vue&type=style&index=0&id=bc6af530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6af530",
  null
  
)

export default component.exports